import { Button } from '@user-portal/wikr-components';

import { selectIsBlackBtn } from 'helpers/abTests';

import * as S from './styled';

type Props = React.ComponentProps<typeof Button> & {
    dataTestId?: string;
};

// The design team requested a style change for primary buttons only.
// Normally, we'd update the color values in themeConfig, but that would affect all places using those colors.
// So we agreed to create a CustomPrimaryButton to override just the needed styles.
const CustomPrimaryButton = ({ ...props }: Props) => {
    // Todo: YG-3885: Use the real experiment hook when required, or delete this flag once the experiment is over
    const isBlackBtn = selectIsBlackBtn();

    return isBlackBtn ? (
        <S.PrimaryButton {...props} backgroundColor="on-primary" />
    ) : (
        <S.DefaultButton backgroundColor="primary-default" {...props} />
    );
};

export default CustomPrimaryButton;
